import React from "react";
import { Box, Tab, Tabs as MuiTabs, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getTabItems } from "../types/tabItemsTypes";

interface TabsProps {
    onTabChange: (index: number) => void;
    currentTab: number;
}

const MobileTabs: React.FC<TabsProps> = ({ onTabChange, currentTab }) => {
    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        onTabChange(newValue);
    };

    const { t } = useTranslation();

    const tabItems = getTabItems(t);

    return (
        <Container>
            <MuiTabs
                value={currentTab}
                onChange={handleChange}
                variant="scrollable"
                TabIndicatorProps={{
                    style: {
                        backgroundColor: "#005F73",
                    },
                }}
            >
                {tabItems.map((label, index) => (
                    <Tab
                        key={index}
                        label={label}
                        sx={{
                            textTransform: "capitalize",
                            fontWeight: 400,
                            color: "#333",
                            overflow: "auto",

                            "&.Mui-selected": {
                                color: "#005F73",
                                fontWeight: 600,
                            },
                            "&:hover": {
                                color: "#005F73",
                            },
                        }}
                    />
                ))}
            </MuiTabs>
        </Container>
    );
};

export default MobileTabs;

const Container = styled(Box)({
    display: "flex",
    height: "fit-content",

    width: "100%",
    marginTop: "40px",
    backgroundColor: "#F0F4F8",
    borderBottom: 1,
    borderColor: "divider",
    overflow: "auto",
});
